/**
 * This is used to override the origin of the client and bearer token used
 * This is mainly used when running MCP Apps where the app is hosted in a different origin and we need to repoint requests to our app
 */
let origin: URL | undefined = undefined;

export const getOriginOverrideUrlObject = (): URL | undefined => origin;

export const setOriginOverrideUrlObject = (newOrigin: URL): void => {
  origin = newOrigin;
};

let bearerToken: string | undefined = undefined;

export const setMcpBearerToken = (token: string): void => {
  bearerToken = token;
};

export const getMcpBearerToken = (): string | undefined => bearerToken;

let orgId: string | undefined = undefined;

export const setMcpOrgId = (overrideOrgId: string): void => {
  orgId = overrideOrgId;
};

export const getMcpOrgId = (): string | undefined => orgId;
